/* global axios */
/* global Qs */

axios.defaults.baseURL = window.api_host + '/web_api/';
if (process.env.NODE_ENV === 'development') {
    axios.defaults.baseURL = 'http://10.17.191.115:8081/web_api/' //http://10.17.191.115:8081测试环境下为本机地址，并且需要开启vue.config.js里proxy代理，正式环境需要注释掉proxy代理
}
axios.defaults.withCredentials = true;

export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        })
            .then(res => {
                if (res.status == 200) {
                    resolve(res.data.data)
                } else {
                    reject(res)
                }
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function post(url, data) {
    
    return new Promise((resolve, reject) => {
        axios.post(url, Qs.stringify(data), {
            // header: {
            //     'Content-Type': 'application/x-www-form-urlencoded'
            // }
        })
            .then(res => {
                if (res.status == 200 && res.data.error_no == 0) {
                    resolve(res.data.data)
                } else {
                    if(res.data.error_no == 100) {
                        window.VM.$store.commit('logout');
                        window.VM.$router.push('/');
                        window.VM.$emit('login');
                    }
                    alert(res.data.error_msg);
                    // reject(res.data.error_no);
                    if(res.error_no == 202) {
                        reject(res.data.error_no);
                    }
                }
            }, err => reject(err))
    })
}
